import restSetMyPaymentMethod from './restSetMyPaymentMethod';

export default restSetMyPaymentMethod;
